// src/components/Paywall.jsx
// Thin wrapper — renders SubscriptionPage in paywallMode overlay.
// All payment logic lives in subscription.jsx + payment.jsx (Monnify).

import React from 'react';
import SubscriptionPage from './SubscriptionPage';

export default function Paywall({ reason, onClose, redirectAfter = '/scan?force=true' }) {
  return (
    <SubscriptionPage
      paywallMode={true}
      paywallReason={reason}
      onClose={onClose}
      redirectAfter={redirectAfter}
    />
  );
}
